// =============================================================================
// paginaArticulos.js
// =============================================================================
import { mostrarToast, obtenerUrlBackend } from './utilerias.js';

export function paginaArticulos() {
    const html = `
        <div class="container-fluid"> 

            <div id="estado-contenedor" class="alert alert-info" role="alert">
                <p id="mensaje-estado" class="mb-0">Cargando datos del servidor...</p>
            </div>

            <div class="table-responsive">
                <table id="tabla-articulos" class="table table-striped table-hover w-100">
                    <thead class="table-light">
                        <tr>
                            <th>Articulo</th>
                            <th>Posición</th>
                            <th>Descripción</th>
                            <th>Costo</th>
                            <th>Precio</th>
                            <th>CPVM</th>
                            <th>Importe</th>
                            <th>%</th>
                            <th>%Acumulado</th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>   
        </div>
    `;

    setTimeout(() => {
        obtenerYRenderizarArticulos();
    }, 100);

    return html;
}

const URL_BASE_API = obtenerUrlBackend('8083');
const URL_API = `${URL_BASE_API}/api/partes`;
const ID_TABLA = '#tabla-articulos';

async function obtenerYRenderizarArticulos() {
    const mensajeEstado = document.getElementById('mensaje-estado');
    mensajeEstado.textContent = "Cargando artículos...";

    try {
        const token = sessionStorage.getItem('token_teresita');
        const respuesta = await fetch(URL_API, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        });

        if (!respuesta.ok) {
            throw new Error(`Error ${respuesta.status}: Fallo al conectar con la API.`);
        }

        const articulos = await respuesta.json();
        inicializarDataTable(articulos);
        mensajeEstado.textContent = `✅ Mostrando ${articulos.length} artículos.`;

    } catch (error) {
        console.error("Fallo al obtener artículos:", error);
        mostrarToast(error.message, 'warning'); 

        const estadoContenedor = document.getElementById('estado-contenedor');
        if (estadoContenedor) {
            estadoContenedor.classList.replace('alert-info', 'alert-danger');
        }
    }
}

function inicializarDataTable(datos) {
    // ============================================================
    // 1. ESTILOS PERSONALIZADOS
    // ============================================================
    if (!document.getElementById('articulos-custom-styles')) {
        const style = document.createElement('style');
        style.id = 'articulos-custom-styles';
        style.innerHTML = `
            #tabla-articulos td { white-space: nowrap !important; }
            .columna-idarticulo { font-family: monospace; font-weight: bold; }
            .filtro-container-celda { margin-top: 5px; }
            .filtro-columna { font-size: 0.85rem; }
        `;
        document.head.appendChild(style);
    }

    // ============================================================
    // 2. DEFINICIÓN DE COLUMNAS Y METADATOS
    // ============================================================
    const columnasDef = [
        { 
            data: 'vp_part_part', 
            title: 'Articulo',
            className: 'columna-idarticulo', 
            width: '200px',
            render: function (data) {
                return `<a href="#" class="detalle-articulo text-decoration-none" data-id="${data}">${data}</a>`;
            }
        },
        { data: 'posicion_articulo', title: 'Posición', className: 'text-center' },
        { data: 'vp_part_desc_part', title: 'Descripción' },
        { data: 'vp_part_costo_metro', title: 'Costo', render: $.fn.dataTable.render.number(',', '.', 2, '$') },
        { data: 'vp_part_precio_metro', title: 'Precio', render: $.fn.dataTable.render.number(',', '.', 2, '$') },
        { data: 'vp_part_cvpm_metro', title: 'CPVM', render: $.fn.dataTable.render.number(',', '.', 2) },
        { data: 'vp_part_monto_metros', title: 'Importe', render: $.fn.dataTable.render.number(',', '.', 2, '$') },
        { 
            data: 'vp_part_porc', 
            title: '%',
            render: data => parseFloat(data).toFixed(2) + '%'
        },
        { 
            data: 'vp_part_porc_acum', 
            title: '%Acumulado',
            render: data => parseFloat(data).toFixed(2) + '%'
        }
    ];

    // Columnas que permiten filtros con operadores matemáticos
    const columnasNumericas = ['Costo', 'Precio', 'CPVM', 'Importe', '%', '%Acumulado'];

    // ============================================================
    // 3. REGISTRO DEL CUSTOM SEARCH (solo una vez)
    // ============================================================
    let customSearchRegistrado = false;
    if ($.fn.dataTable.ext.search && $.fn.dataTable.ext.search.length > 0) {
        for (let i = 0; i < $.fn.dataTable.ext.search.length; i++) {
            const fn = $.fn.dataTable.ext.search[i];
            if (fn && fn._tablaId === 'tabla-articulos') {
                customSearchRegistrado = true;
                break;
            }
        }
    }

    if (!customSearchRegistrado) {
        const customSearchFn = function(settings, data, dataIndex) {
            if (settings.sTableId !== 'tabla-articulos') return true;

            const api = new $.fn.dataTable.Api(settings);
            const headers = api.columns().header().toArray();

            for (let i = 0; i < headers.length; i++) {
                const header = $(headers[i]);
                const title = columnasDef[i] ? columnasDef[i].title : '';

                if (!columnasNumericas.includes(title)) {
                    continue;
                }

                const cellData = data[i];
                const filtroInput = header.find('input.filtro-columna').val() || '';
                const match = filtroInput.match(/^([<>=]+)\s*([\d.,]+)$/);

                if (!match) {
                    continue;
                }

                const operator = match[1];
                let numFilter = match[2];

                const numData = parseFloat(cellData.replace(/[^0-9.-]+/g, ''));
                numFilter = parseFloat(numFilter.replace(/[^0-9.-]+/g, ''));

                if (isNaN(numData) || isNaN(numFilter)) {
                    return false; 
                }

                let result = false;
                switch (operator) {
                    case '>': result = numData > numFilter; break;
                    case '<': result = numData < numFilter; break;
                    case '>=': result = numData >= numFilter; break;
                    case '<=': result = numData <= numFilter; break;
                    case '=': result = Math.abs(numData - numFilter) < 0.001; break;
                    case '==': result = Math.abs(numData - numFilter) < 0.001; break;
                    default: result = true;
                }

                if (!result) {
                    return false;
                }
            }
            return true;
        };

        customSearchFn._tablaId = 'tabla-articulos';
        $.fn.dataTable.ext.search.push(customSearchFn);
    }

    // ============================================================
    // 4. INICIALIZACIÓN DE DATATABLES CON PERSISTENCIA
    // ============================================================
    var table = $(ID_TABLA).DataTable({
        data: datos,
        columns: columnasDef,
        destroy: true,        

        stateSave: true,
        stateDuration: -1,    

        stateSaveCallback: function (settings, data) {
            data.filtrosOperadores = {};

            const api = new $.fn.dataTable.Api(settings);
            api.columns().every(function (idx) {
                const header = $(this.header());
                const input = header.find('input.filtro-columna');
                const valor = input.val() || '';
                const title = columnasDef[idx] ? columnasDef[idx].title : '';

                if (columnasNumericas.includes(title) && valor.match(/^[<>=]+/)) {
                    data.filtrosOperadores[idx] = valor;
                }
            });

            localStorage.setItem(
                'DataTables_' + settings.sInstance + '_' + location.pathname,
                JSON.stringify(data)
            );
        },

        stateLoadCallback: function (settings) {
            const key = 'DataTables_' + settings.sInstance + '_' + location.pathname;
            const data = localStorage.getItem(key);

            if (data) {
                try {
                    return JSON.parse(data);
                } catch (e) {
                    console.warn('Error al parsear estado guardado:', e);
                }
            }
            return null;
        },

        language: {
            url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json"
        },
        paging: true,
        order: [],
        searching: true,
        scrollX: true,
        autoWidth: false,
        lengthChange: true,
        pageLength: 50,
        lengthMenu: [
            [10, 25, 50, 100, -1],
            [10, 25, 50, 100, "Todos"]
        ],
        dom: '<"row mb-3 align-items-center" <"col-sm-6"B> <"col-sm-6 text-end"l> >rt<"row" <"col-sm-6"i> <"col-sm-6"p> >',
        buttons: [
            { 
                extend: 'colvis', 
                text: '<i class="fas fa-binoculars fa-lg"></i> Columnas', 
                className: 'btn btn-sm',
                postfixButtons: [
                    {
                        extend: 'colvisRestore',
                        text: '<i class="fas fa-eye"></i> Mostrar Todas',
                        action: function (e, dt, node, config) {
                            dt.columns().visible(true);
                            dt.state.save();
                            dt.columns.adjust().draw(false);

                            setTimeout(function() {
                                dt.columns.adjust();
                            }, 100);
                        }
                    }
                ]
            },            
            {
                extend: 'collection',
                text: '<i class="fas fa-download"></i> Exportar', 
                className: 'btn btn-sm', 
                buttons: [
                    { extend: 'copy', text: '<i class="fas fa-copy"></i> Copiar', exportOptions: {columns: ':visible'} },
                    { extend: 'csv', text: '<i class="fas fa-file-csv"></i> CSV', exportOptions: {columns: ':visible'} },
                    { extend: 'excel', text: '<i class="fas fa-file-excel"></i> Excel', exportOptions: {columns: ':visible'} },
                    { extend: 'pdf', text: '<i class="fas fa-file-pdf"></i> PDF', orientation: 'landscape', exportOptions: {columns: ':visible'} },
                    { extend: 'print', text: '<i class="fas fa-print"></i> Imprimir', exportOptions: {columns: ':visible'} }
                ]
            },
            {
                text: '<i class="fas fa-filter"></i> Limpiar Filtros', 
                className: 'btn btn-sm',
                action: function (e, dt) {
                    $('.filtro-columna').val('');
                    dt.columns().every(function () {
                        this.search(''); 
                    });
                    dt.search('').draw();
                    dt.state.save();         
                    mostrarToast('Filtros limpiados', 'info');
                }
            }
        ],

        // ============================================================
        // INIT COMPLETE: Crear inputs, restaurar valores Y APLICAR FILTROS
        // ============================================================
        initComplete: function () {
            var api = this.api();
            var estadoCargado = api.state.loaded();

            // ============================================================
            // FASE 1: Crear todos los inputs de filtro y poner valores
            // ============================================================
            api.columns().every(function (i) {
                var column = this;
                var headerCelda = $(column.header());

                if (headerCelda.find('.filtro-container-celda').length > 0) {
                    return;
                }

                var title = columnasDef[i] ? columnasDef[i].title : headerCelda.text().trim();
                const esNumerica = columnasNumericas.includes(title);
                let placeholderText = 'Filtrar ' + title;

                if (esNumerica) {
                    placeholderText += ' (Ej: >100)';
                }

                var container = $('<div class="filtro-container-celda mt-1"></div>');
                var input = $('<input type="text" class="filtro-columna form-control form-control-sm" placeholder="' + placeholderText + '" style="font-weight: normal;" />');

                // RESTAURAR VALOR DEL FILTRO
                let valorRestaurado = '';

                // Prioridad 1: Filtros de operadores guardados
                if (estadoCargado && estadoCargado.filtrosOperadores && estadoCargado.filtrosOperadores[i]) {
                    valorRestaurado = estadoCargado.filtrosOperadores[i];
                }
                // Prioridad 2: Búsqueda nativa de DataTables
                else if (estadoCargado && estadoCargado.columns && estadoCargado.columns[i] && estadoCargado.columns[i].search) {
                    valorRestaurado = estadoCargado.columns[i].search.search;
                }

                if (valorRestaurado) {
                    input.val(valorRestaurado);
                }

                input.appendTo(container);
                headerCelda.append(container);

                // Previene que se dispare el ordenamiento de la columna al clickear la caja
                input.on('click', function (e) {
                    e.stopPropagation();
                });

                input.on('keydown', function (e) {
                    if (e.key === 'Enter') {
                        e.stopPropagation();
                        e.preventDefault();
                        $(this).trigger('change');
                    }
                });

                // Evento principal: keyup con debounce
                let timeoutId;
                input.on('keyup change', function () {
                    clearTimeout(timeoutId);
                    const value = this.value;

                    timeoutId = setTimeout(function() {
                        const tieneOperador = value.match(/^[<>=]+/);

                        if (esNumerica && tieneOperador) {
                            // FILTRO CON OPERADOR MATEMÁTICO
                            if (column.search() !== '') {
                                column.search('');
                            }
                            column.draw();
                            api.state.save();
                        } else {
                            // FILTRO TEXTO NORMAL
                            if (column.search() !== value) {
                                column.search(value).draw();
                            }
                        }
                    }, 300);
                });
            });

            // ============================================================
            // FASE 2: APLICAR LOS FILTROS RESTAURADOS
            // ============================================================
            if (estadoCargado) {
                let necesitaRedraw = false;

                api.columns().every(function (i) {
                    var column = this;
                    var title = columnasDef[i] ? columnasDef[i].title : '';
                    const esNumerica = columnasNumericas.includes(title);

                    // Verificar si hay filtro de operador guardado
                    if (estadoCargado.filtrosOperadores && estadoCargado.filtrosOperadores[i]) {
                        // Asegurar que el search nativo esté limpio
                        if (column.search() !== '') {
                            column.search('');
                        }
                        necesitaRedraw = true;
                    }
                    // Verificar si hay filtro nativo guardado
                    else if (estadoCargado.columns && estadoCargado.columns[i] && 
                             estadoCargado.columns[i].search && estadoCargado.columns[i].search.search) {
                        const valor = estadoCargado.columns[i].search.search;
                        const tieneOperador = valor.match(/^[<>=]+/);

                        // Solo aplicar si no es un operador (ya manejado arriba)
                        if (!esNumerica || !tieneOperador) {
                            if (column.search() !== valor) {
                                column.search(valor);
                                necesitaRedraw = true;
                            }
                        }
                    }
                });

                // Forzar un redraw donde el custom search leerá los valores
                if (necesitaRedraw) {
                    api.draw();
                }
            }

            document.getElementById('estado-contenedor').style.display = 'none';
        }
    });
}